var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell",class:{x: _vm.cell.marker=='x', 
  o:_vm.cell.marker=='o'},on:{"click":_vm.markComplete}})}
var staticRenderFns = []

export { render, staticRenderFns }